module.exports = __webpack_public_path__ + "static/media/monitor-heart-rate.ac864b70.svg";